import { render, staticRenderFns } from "./TabBookingDetail.vue?vue&type=template&id=24e84447&scoped=true&"
import script from "./TabBookingDetail.vue?vue&type=script&lang=js&"
export * from "./TabBookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TabBookingDetail.vue?vue&type=style&index=0&id=24e84447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e84447",
  null
  
)

export default component.exports